export { useResultsCarousel } from './useResultsCarousel';
